import * as Yup from 'yup'

export const PASSWORD_POLICY_HINT =
  'Use at least 8 characters with at least one letter and one number.'

const STRONG_PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d).+$/

export const strongPasswordSchema = (fieldLabel = 'Password') =>
  Yup.string()
    .min(8, `${fieldLabel} must be at least 8 characters`)
    .matches(STRONG_PASSWORD_REGEX, `${fieldLabel} must include at least one letter and one number`)
    .required(`${fieldLabel} is required`)
